import { SessionParams } from '@shared/types/session-params';

type ResolvedSessionParams = Required<SessionParams>;

export function getSessionParamsFromUrl(): ResolvedSessionParams {
  const url = new URL(window.location.href);
  const queryParams = new URLSearchParams(url.search);
  return {
    token: queryParams.get('token') ?? '',
    instance: queryParams.get('instance') ?? '',
    sessionId: queryParams.get('sessionId') ?? '',
    gameUuid: queryParams.get('gameUuid') ?? '',
    isFromHub: queryParams.get('hub') === 'true',
    navigateToPlay: queryParams.get('navigateToPlay') === 'true',
    hubGameUuid: queryParams.get('hubGameUuid') ?? '',
    language: queryParams.get('language') ?? 'en',
  };
}
